<template>
  <div
    ref="detailsHeroAutoSizePanelElement"
    class="details-hero-auto-size-panel"
    :class="{
      'details-hero-auto-size-panel--freeze': isFreeze,
    }"
    :style="rootStyleList"
  >
    <tm-auto-size-panel
      :max-visible-items="maxVisibleItems"
      class="details-hero-auto-size-panel__content"
      extra-offset-for-focus
      :dropdown-close-on-click="dropdownCloseOnClick"
      :is-freeze="isFreeze"
    >
      <template v-slot:dropdown-activator="{ visibleItemsCount }">
        <tm-auto-size-panel-mobile-activator
          :visible-items-count="visibleItemsCount"
          :only-icon="isMobile"
        />
      </template>
      <slot />
    </tm-auto-size-panel>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, type StyleValue } from '@/composition/vue/compositionApi'
import { useBreakpoints } from '@/composition/breakpoints'
import TmAutoSizePanelMobileActivator from '@/components/shared/autoSize/panel/TmAutoSizePanelMobileActivator.vue'
import TmLogicError from '@/core/error/tmLogicError'
import TmAutoSizePanel from '@/components/shared/autoSize/TmAutoSizePanel.vue'

const props = defineProps<{
  maxVisibleItems?: number
  dropdownCloseOnClick?: boolean
  rootStyles?: Partial<Pick<CSSStyleDeclaration, 'minWidth' | 'maxWidth' | 'height'>>
  isFreeze?: boolean
}>()

const { isMobile } = useBreakpoints()

const detailsHeroAutoSizePanelElement = ref<HTMLDivElement | null>(null)

const rootStyleList = computed(() => {
  const style: StyleValue = {}
  if (!props.rootStyles) {
    return style
  }
  if (props.rootStyles.minWidth) {
    style.minWidth = props.rootStyles.minWidth
  }
  if (props.rootStyles.maxWidth) {
    style.maxWidth = props.rootStyles.maxWidth
  }
  if (props.rootStyles.height) {
    style.height = props.rootStyles.height
  }
  return style
})

const getRootElement = () => {
  if (!detailsHeroAutoSizePanelElement.value) {
    throw new TmLogicError('detailsHeroAutoSizePanelElement is null')
  }
  return detailsHeroAutoSizePanelElement.value
}

defineExpose({
  getRootElement,
})
</script>

<style scoped lang="scss">
@import '@/styles/mixins';
$tmAutoSizePanelGap: 8px;

.details-hero-auto-size-panel {
  display: flex;
  align-items: center;
  align-self: flex-start;
  flex-grow: 1;
  flex-shrink: 0;
  max-width: 40%;
  min-width: 40px;
  margin: 0 -4px 0 auto;
  padding: 4px;
  @include overflow-hidden-with-clip-margin;

  &--freeze {
    max-width: unset;
  }

  @include media-md-min {
    min-width: 110px;
  }

  &__content {
    --tm-auto-size-panel-gap: #{$tmAutoSizePanelGap};
    margin-right: -4px;
    justify-content: flex-end;
    transform: translateX(#{$tmAutoSizePanelGap});
  }
}
</style>
